// import Suppliers from '../../../PUR/Settings/Suppliers/Index';

// const Index = () => {
//   //________________________________

//   return <Suppliers />;
// };

// export default Index;

import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card';
import Button from 'react-bootstrap/Button';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import NtxTable from '@components/DataTable/NtxTable';
import Loading from '@components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const { SuppliersList, loading, error } = useGetSuppliersList();

  const columns = [
    { title: t('SupplierName'), key: 'name' },
    { title: t('SupplierNumber'), key: 'num' },
    { title: t('TradingName'), key: 'name2' },
    { title: '', key: 'action', className: 'text-end' }
  ];

  const tableData =
    SuppliersList?.filter(f => f.parentId === null)?.map(item => {
      let rowClass;

      return {
        name: i18n.language === 'en' ? item.name : item.name2,
        num: '000',
        name2: item.tradingName,

        action: (
          <button
            hidden={!HasPermission('FleetEditResource')}
            className='btn btn-sm btn-outline-theme'
            onClick={() =>
              navigate(`${item.id}/UpdateSupplier`, {
                state: {
                  name: i18n.language === 'en' ? item.name : item.name2
                }
              })
            }
          >
            {t('SupplierDetails')}
          </button>
        )
      };
    }) || [];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: t('Suppliers'),
              link: null
            }
          ]}
          PageName={t('Suppliers')}
        />
        <div className='ms-auto'>
          <Link hidden={!HasPermission('FleetAddResource')} to='AddSupplier' className='btn btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddNewSupplier')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns || []}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch={true}
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </>
  );
};

export default Index;
